import React, {FC, useState} from 'react'
import AlertMessage from '../../../common/alert/AlertMsg'
import SharedData from '../../../common/SharedData'
import {enqueueBulkEdit} from '../core/_requests'
import Loader from '../../../common/Loader'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

type IProps = {
  bulkFile: any
  setBulkFile: React.Dispatch<any>
  disableActiveOffers: boolean
}
const EditSubmitButtonRow: FC<IProps> = ({bulkFile, setBulkFile, disableActiveOffers}) => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const isFormHasError = () => {
    let hasError = false
    setBulkFile({...bulkFile, error: false})
    if (!bulkFile.value) {
      setBulkFile({...bulkFile, error: true})
      hasError = true
    }
    return hasError
  }
  const handleSubmit = async () => {
    if (isFormHasError()) return
    setIsLoading(true)
    try {
      // Async: the edit sheet is queued and processed in the background — the
      // supplier tracks progress + downloads the result on the Bulk Jobs page,
      // instead of waiting in-request for the result blob.
      const res = await enqueueBulkEdit(currentUser?.token, bulkFile.value, disableActiveOffers, language)
      if (res?.data?.job_id) {
        navigate('/products/bulk-jobs')
      } else {
        setError(true)
      }
    } catch (exp) {
      setError(true)
    }
    setIsLoading(false)
  }

  return (
    <>
      <div className='adb-actionbar'>
        <div className='adb-actionbar-note'>
          <i className='fas fa-shield-halved' aria-hidden='true' />
          <span>{formatMessage({id: 'by_uploading_products_stnrd'})}</span>
        </div>
        <button onClick={handleSubmit} className='adb-actionbar-btn'>
          {formatMessage({id: 'upload'})}
        </button>
      </div>
      {isLoading && <Loader isFull={true} />}
      {error === true && (
        <AlertMessage
          title={formatMessage({id: 'something_wrong_title'})}
          message={formatMessage({id: 'something_wrong_desc'})}
          onClose={() => setError(false)}
        />
      )}
    </>
  )
}

export default EditSubmitButtonRow
